import * as React from 'react';
import { Loading } from '../welcome/loading';
export const SignInRedirectPage = () => {
    return <Loading />;
};
export default SignInRedirectPage;
